import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { POSTS } from "@/data/posts";

export default function Blog() {
    return (
        <div className="pt-24 md:pt-32 pb-24" data-testid="blog-page">
            <Seo
                title="The Greenz Journal — Cannabis Guides & DC Dispensary Blog | District Greenz DMV"
                description="Cannabis guides from District Greenz DMV: indica vs sativa vs hybrid, edibles for beginners, how ordering and delivery works in Washington DC, and DC's gifting model explained."
                path="/blog"
            />
            <div className="container-x">
                <Reveal>
                    <p className="eyebrow text-gold">The Greenz Journal</p>
                    <h1 className="mt-3 font-display text-4xl md:text-6xl font-extrabold text-bone max-w-3xl leading-[1.02]">
                        Notes from the shop.
                    </h1>
                    <p className="mt-5 max-w-xl text-bone/70 leading-relaxed">
                        Straightforward guides on strains, edibles and how cannabis works in Washington DC — written
                        by the people who answer the phone at 3am.
                    </p>
                </Reveal>

                <div className="mt-12 grid gap-6 md:grid-cols-2" data-testid="blog-grid">
                    {POSTS.map((post, i) => (
                        <Reveal key={post.slug} delay={(i % 2) * 0.08}>
                            <Link
                                to={`/blog/${post.slug}`}
                                data-testid={`blog-card-${post.slug}`}
                                className="group flex h-full flex-col overflow-hidden rounded-3xl border border-leaf/12 bg-moss/40 transition-all duration-500 hover:border-leaf/40 hover:shadow-[0_20px_60px_-20px_rgba(76,175,80,0.35)]"
                            >
                                <div className="relative aspect-[16/9] overflow-hidden">
                                    <img
                                        src={post.image}
                                        alt={post.title}
                                        loading="lazy"
                                        className="h-full w-full object-cover opacity-70 transition-all duration-700 group-hover:scale-105 group-hover:opacity-90"
                                    />
                                    <span className="absolute left-4 top-4 rounded-full bg-ink/80 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-leaf-bright backdrop-blur">
                                        {post.tag}
                                    </span>
                                </div>
                                <div className="flex flex-1 flex-col p-6">
                                    <h2 className="font-display text-xl md:text-2xl font-bold leading-snug text-bone group-hover:text-leaf-bright transition-colors">
                                        {post.title}
                                    </h2>
                                    <p className="mt-3 flex-1 text-sm leading-relaxed text-sage">{post.excerpt}</p>
                                    <div className="mt-5 flex items-center justify-between border-t border-leaf/10 pt-4">
                                        <span className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-sage">
                                            <Clock size={12} /> {post.readTime} · {post.date}
                                        </span>
                                        <span className="flex h-9 w-9 items-center justify-center rounded-full border border-leaf/25 text-leaf-bright transition-all duration-300 group-hover:bg-leaf group-hover:text-ink">
                                            <ArrowRight size={15} />
                                        </span>
                                    </div>
                                </div>
                            </Link>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    );
}
